import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import rehydrator from "./ListItem.rehydrator";
import { Consumer as CurrentListItemConsumer } from "../../currentListItemContext";

var ListItem = function ListItem(_ref) {
  var id = _ref.id,
      category = _ref.category,
      children = _ref.children;
  var getClassName = getClassNameFactory(ListItem.displayName);
  return /*#__PURE__*/React.createElement(CurrentListItemConsumer, null, function (currentListItem) {
    return /*#__PURE__*/React.createElement("div", {
      // eslint-disable-next-line jsx-a11y/aria-role
      role: "ListItem",
      "data-category": category,
      "data-rehydratable": getRehydratableName(ListItem.displayName),
      "data-id": id,
      hidden: currentListItem !== category,
      className: getClassName()
    }, /*#__PURE__*/React.createElement("div", {
      "data-rehydratable-children": true
    }, children));
  });
};

ListItem.displayName = "FilteredList.ListItem";
ListItem.rehydrator = rehydrator;
export default ListItem;